import useAsyncData from "../../../hooks/use-async-data";
import planEntryService from "../plan-entry.service";
import PlanEntryRoadRoute from "./plan-entry-road-route";
import PlanEntryRoadRouteParams from "./plan-entry-road-route-params";

const usePlanEntryRoadRoutes = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<PlanEntryRoadRoute[][]>([]);

  const load = async (params: PlanEntryRoadRouteParams[]): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const routeRoadRoutes = await Promise.all(
        params.map(async (param) => {
          return await planEntryService.getRoute(param);
        }),
      );

      setData(routeRoadRoutes);
      setIsLoading(false);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default usePlanEntryRoadRoutes;
